import { Helmet } from "react-helmet";
import PoliciesLayout from "../section/policies/policy-layout";
import jsonData from '../data/policies/en/termsAndConditions.json';

const TermsNConditionsPage = () => {
    <Helmet>
        <title>Terms & Conditions | Digital Tourism Sri Lanka</title> 
        <meta name="description" content="Read the official terms and conditions governing the use of Digital Tourism’s websites, digital platforms, and travel technology services." />
        <meta name="keywords" content="Digital Tourism terms and conditions, travel platform policies, tourism service terms, Sri Lanka tech policies" />
    </Helmet>

    return (
        <>
            <PoliciesLayout json={jsonData}/>
        </>
    );
}

export default TermsNConditionsPage;